export default __webpack_public_path__ + "static/media/couple.0eddaec9.jpg";